const isActivePath = (currentPath: string, href: string) => {
  if (href === '/') return currentPath === '/'

  return (
    currentPath === href ||
    currentPath.startsWith(href + '/') ||
    href.startsWith(currentPath + '?')
  )
}

export { isActivePath }
